module.exports = __webpack_public_path__ + "static/media/Vill.80228915.mp3";